// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__b6cbs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /*grid-template-rows: repeat(3, 1fr);*/
    --folder-offset: 40px;

    /*max-height: calc(100vh - var(--header-height) - 40px);*/
}

.styles_box__nHkcb {
    border: 0.25px solid #7b848e;
    border-right: 0;
    border-bottom: 0;
    position: relative;
    padding: 57px;
    cursor: pointer;
    /*transition: background-color 0.4s;*/
    max-height: 300px;
    /*padding-top: 16%;*/
    display: flex;
    flex-direction: column;
}

.styles_box__nHkcb:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(var(--primary-color-light), var(--white-active));
    opacity: 0;
    transition: opacity 0.4s;
}

.styles_box__nHkcb:hover:before {
    opacity: 1;
}

.styles_boxInner__r7HX8 {
    /*position: absolute;*/
    /*top: 0;*/
    /*height: 100%;*/
}

.styles_box__nHkcb:nth-child(3n) {
    border-right: 0.25px solid #7b848e;
}

.styles_box__nHkcb:nth-last-child(1),
.styles_box__nHkcb:nth-last-child(2),
.styles_box__nHkcb:nth-last-child(3) {
    border-bottom: 0.25px solid #7b848e;
}

.styles_box__nHkcb p,
.styles_box__nHkcb span {
    text-align: center;
    padding: 0 8%;
    transition:
        transform 0.4s,
        color 0.4s;
}

.styles_box__nHkcb p {
    line-height: 30px;
}

.styles_box__nHkcb:hover {
    /*background: var(--primary-color);*/
    /*color: #fff;*/
}

.styles_box__nHkcb:hover p,
.styles_box__nHkcb:hover span {
    /*color: #fff;*/
    transform: scale(1.1) translateY(14px);
}

.styles_number__1rier {
    position: absolute;
    top: 26px;
    left: 14px;
    font-size: 30px;
    font-weight: 300;
    transition: color 0.4s;
    color: #7b848e;
}

.styles_folderContainer__n12HM {
    position: relative;
    margin: auto;
    max-height: 100%;
    display: flex;
    flex-direction: column;
}

.styles_folder__y6V2x {
    position: relative;
    /*width: 226px;*/
    margin: auto;
    /*max-height: 100%;*/
    /*width: 24vh;*/
}

.styles_itemWrapper__VPd48 {
    width: 140px;
    height: 140px;
    margin: auto;
    position: relative;
    max-height: 100%;
}

.styles_item__GnJTb {
    width: inherit;
    height: 140px;
    border: 0.5px solid #7b848e;
    position: absolute;
    --offset: 8px;
    margin: var(--offset) auto 0;
    left: calc(var(--offset) * -1);
    top: calc(var(--offset) * -1);
    background: #fff;
}

.styles_item__GnJTb:before,
.styles_item__GnJTb:after {
    content: '';
    display: block;
    position: absolute;
    width: inherit;
    height: inherit;
    border: inherit;
    background: inherit;
}

.styles_item__GnJTb:before {
    left: var(--offset);
    top: var(--offset);
}

.styles_item__GnJTb:after {
    left: calc(var(--offset) * 2);
    top: calc(var(--offset) * 2);
}

.styles_imgContainer__eR4mb {
    position: absolute;
    top: 0;
    width: 100%;
    bottom: calc(var(--folder-offset) * -1);
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 100%;
}

.styles_folderImg__AYY6S {
    width: 200px;
    max-width: 130%;

    /*max-height: 80%;*/
    /*width: auto;*/
    /*display: block;*/

    margin: calc(var(--folder-offset, 32px) + 32px) auto 0;
}

.styles_typeImg__g8hOY {
    width: 100px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 32px 30px;
    /*margin-top: 0px;*/
}

.styles_typeImg__g8hOY.styles_secondary__Nvymx {
    z-index: 1;
    /*margin-top: -50px;*/
    /*margin-left: 20px;*/
}

.styles_folderImg__AYY6S.styles_secondary__Nvymx {
    position: relative;
    z-index: 2;
}

.styles_type__CIOjv {
    margin: calc(var(--folder-offset, 32px)) auto 0;
    text-align: center;
    color: var(--primary-color);
    max-width: 100%;
}

@media (max-height: 1100px) {
    .styles_responsive__eGJrl .styles_container__b6cbs {
        grid-template-rows: repeat(3, 1fr);
        max-height: calc(100vh - var(--header-height) - 40px);
    }

    .styles_box__nHkcb {
        /*min-height: calc((100vh - var(--header-height) - 80px) / 3);*/
        min-height: 300px;
        padding: 0;
    }

    .styles_responsive__eGJrl .styles_folder__y6V2x {
        max-height: 100%;
        width: 24vh;
    }

    .styles_responsive__eGJrl .styles_itemWrapper__VPd48 {
        width: 13vh;
        height: 13vh;
    }

    .styles_responsive__eGJrl .styles_item__GnJTb {
        height: 13vh;
    }

    .styles_responsive__eGJrl .styles_folderImg__AYY6S {
        width: 18vh;
    }

    .styles_responsive__eGJrl .styles_typeImg__g8hOY {
        width: 10vh;
        margin: 3.5vh 8vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Workflow/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,sCAAsC;IACtC,qBAAqB;;IAErB,yDAAyD;AAC7D;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,qCAAqC;IACrC,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kFAAkF;IAClF,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;;IAGI,mCAAmC;AACvC;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb;;kBAEc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;;IAEf,mBAAmB;IACnB,eAAe;IACf,kBAAkB;;IAElB,sDAAsD;AAC1D;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI;QACI,kCAAkC;QAClC,qDAAqD;IACzD;;IAEA;QACI,+DAA+D;QAC/D,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;AACJ","sourcesContent":[".container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    /*grid-template-rows: repeat(3, 1fr);*/\n    --folder-offset: 40px;\n\n    /*max-height: calc(100vh - var(--header-height) - 40px);*/\n}\n\n.box {\n    border: 0.25px solid #7b848e;\n    border-right: 0;\n    border-bottom: 0;\n    position: relative;\n    padding: 57px;\n    cursor: pointer;\n    /*transition: background-color 0.4s;*/\n    max-height: 300px;\n    /*padding-top: 16%;*/\n    display: flex;\n    flex-direction: column;\n}\n\n.box:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: linear-gradient(var(--primary-color-light), var(--white-active));\n    opacity: 0;\n    transition: opacity 0.4s;\n}\n\n.box:hover:before {\n    opacity: 1;\n}\n\n.boxInner {\n    /*position: absolute;*/\n    /*top: 0;*/\n    /*height: 100%;*/\n}\n\n.box:nth-child(3n) {\n    border-right: 0.25px solid #7b848e;\n}\n\n.box:nth-last-child(1),\n.box:nth-last-child(2),\n.box:nth-last-child(3) {\n    border-bottom: 0.25px solid #7b848e;\n}\n\n.box p,\n.box span {\n    text-align: center;\n    padding: 0 8%;\n    transition:\n        transform 0.4s,\n        color 0.4s;\n}\n\n.box p {\n    line-height: 30px;\n}\n\n.box:hover {\n    /*background: var(--primary-color);*/\n    /*color: #fff;*/\n}\n\n.box:hover p,\n.box:hover span {\n    /*color: #fff;*/\n    transform: scale(1.1) translateY(14px);\n}\n\n.number {\n    position: absolute;\n    top: 26px;\n    left: 14px;\n    font-size: 30px;\n    font-weight: 300;\n    transition: color 0.4s;\n    color: #7b848e;\n}\n\n.folderContainer {\n    position: relative;\n    margin: auto;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.folder {\n    position: relative;\n    /*width: 226px;*/\n    margin: auto;\n    /*max-height: 100%;*/\n    /*width: 24vh;*/\n}\n\n.itemWrapper {\n    width: 140px;\n    height: 140px;\n    margin: auto;\n    position: relative;\n    max-height: 100%;\n}\n\n.item {\n    width: inherit;\n    height: 140px;\n    border: 0.5px solid #7b848e;\n    position: absolute;\n    --offset: 8px;\n    margin: var(--offset) auto 0;\n    left: calc(var(--offset) * -1);\n    top: calc(var(--offset) * -1);\n    background: #fff;\n}\n\n.item:before,\n.item:after {\n    content: '';\n    display: block;\n    position: absolute;\n    width: inherit;\n    height: inherit;\n    border: inherit;\n    background: inherit;\n}\n\n.item:before {\n    left: var(--offset);\n    top: var(--offset);\n}\n\n.item:after {\n    left: calc(var(--offset) * 2);\n    top: calc(var(--offset) * 2);\n}\n\n.imgContainer {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    bottom: calc(var(--folder-offset) * -1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-height: 100%;\n}\n\n.folderImg {\n    width: 200px;\n    max-width: 130%;\n\n    /*max-height: 80%;*/\n    /*width: auto;*/\n    /*display: block;*/\n\n    margin: calc(var(--folder-offset, 32px) + 32px) auto 0;\n}\n\n.typeImg {\n    width: 100px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: 32px 30px;\n    /*margin-top: 0px;*/\n}\n\n.typeImg.secondary {\n    z-index: 1;\n    /*margin-top: -50px;*/\n    /*margin-left: 20px;*/\n}\n\n.folderImg.secondary {\n    position: relative;\n    z-index: 2;\n}\n\n.type {\n    margin: calc(var(--folder-offset, 32px)) auto 0;\n    text-align: center;\n    color: var(--primary-color);\n    max-width: 100%;\n}\n\n@media (max-height: 1100px) {\n    .responsive .container {\n        grid-template-rows: repeat(3, 1fr);\n        max-height: calc(100vh - var(--header-height) - 40px);\n    }\n\n    .box {\n        /*min-height: calc((100vh - var(--header-height) - 80px) / 3);*/\n        min-height: 300px;\n        padding: 0;\n    }\n\n    .responsive .folder {\n        max-height: 100%;\n        width: 24vh;\n    }\n\n    .responsive .itemWrapper {\n        width: 13vh;\n        height: 13vh;\n    }\n\n    .responsive .item {\n        height: 13vh;\n    }\n\n    .responsive .folderImg {\n        width: 18vh;\n    }\n\n    .responsive .typeImg {\n        width: 10vh;\n        margin: 3.5vh 8vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__b6cbs`,
	"box": `styles_box__nHkcb`,
	"boxInner": `styles_boxInner__r7HX8`,
	"number": `styles_number__1rier`,
	"folderContainer": `styles_folderContainer__n12HM`,
	"folder": `styles_folder__y6V2x`,
	"itemWrapper": `styles_itemWrapper__VPd48`,
	"item": `styles_item__GnJTb`,
	"imgContainer": `styles_imgContainer__eR4mb`,
	"folderImg": `styles_folderImg__AYY6S`,
	"typeImg": `styles_typeImg__g8hOY`,
	"secondary": `styles_secondary__Nvymx`,
	"type": `styles_type__CIOjv`,
	"responsive": `styles_responsive__eGJrl`
};
export default ___CSS_LOADER_EXPORT___;
